import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { JoyrideModule } from 'ngx-joyride';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RecaptchaModule } from 'ng-recaptcha';


// Usuarios
import { ListUsuariosComponent } from './usuarios/list-usuarios.component';
import { NewUsuarioComponent } from './usuarios/new-usuario.component';
import { DetailUsuarioComponent } from './usuarios/detail-usuario.component';

// Tabla avanzada con buscador
import { AdvancedTableModule } from "./shared/advanced-table/advanced-table.module";

// Arbitros
import { ListArbitrosComponent } from './arbitros/list-arbitros.component';
import { DetailArbitroComponent } from './arbitros/detail-arbitro.component';
import { BuscadorArbitrosComponent } from './arbitros/buscador-arbitros.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Select2Module } from 'ng-select2-component';

// Plantillas
import { ListPlantillasComponent } from './plantillas/list-plantillas.component';
import { NewPlantillaComponent } from './plantillas/new-plantilla.component';
import { FoldersPlantillaComponent } from './plantillas/folders-plantilla.component';
import { FileExplorerComponent } from './file-explorer/file-explorer.component';
import { DetailPlantillaComponent } from './plantillas/detail-plantilla.component';
import { ListCasosComponent } from './casos/list-casos.component';
import { NewCasoComponent } from './casos/new-caso.component';
import { DetailCasoComponent } from './casos/detail-caso.component';
import { GestionComponent } from './casos/gestion.component';
import { ListPartesComponent } from './partes/list-partes.component';
import { DetailParteComponent } from './partes/detail-parte.component';
import { NewParteComponent } from './partes/new-parte.component';
import { RepresentantesComponent } from './partes/representantes.component';

// Upload
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FileDropDirective } from './file-upload/file-drop.directive';

import { SafeResourceUrlPipe } from './file-explorer/safeResourceUrl';

// Angular material
import { MatSnackBarModule } from '@angular/material/snack-bar';

// Institucion
import { GestionInstitucionComponent } from './institucion/gestion-institucion.component';
import { GestionTribunalComponent } from './tribunal/gestion-tribunal.component';

// Representantes
import { ListRepresentantesComponent } from './representantes/list-representantes.component';
import { DetailRepresentanteComponent } from './representantes/detail-representante.component';
import { NewRepresentanteComponent } from './representantes/new-representante.component';

// Financiero
import { GestionComponentFinanciero } from './financiero/gestion.component';
import { RegistroPagosComponent } from './financiero/registro-pagos.component';
import { TablaFinancieraComponent } from './financiero/tabla-financiera.component';
import { InfoGeneralComponent } from './casos/info-general.component';
import { CaracteristicasArbitrajeComponent } from './casos/caracteristicas-arbitraje.component';
import { ComentariosInternosComponent } from './casos/comentarios-internos.component';
import { InicioComponent } from './casos/inicio.component';
import { ListLogComponent } from './log/list-log.component';
import { LogPlataformaComponent } from './log/log-plataforma.component';

// Locale
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BuscadorArchivosComponent } from './buscador-archivos/buscador-archivos.component';
import { HitosProcesalesComponent } from './hitos-procesales/hitos-procesales.component';
import { InformesComponent } from './informes/informes.component';
import { DiasInhabilesComponent } from './dias-inhabiles/dias-inhabiles.component';
import { CalendarioHitosComponent } from './calendario-hitos/calendario-hitos.component';
import { FullCalendarModule } from '@fullcalendar/angular';



registerLocaleData(localeEs, 'es');




@NgModule({
    declarations: [AppComponent, ListUsuariosComponent, NewUsuarioComponent, ListArbitrosComponent, DetailArbitroComponent, DetailUsuarioComponent, BuscadorArbitrosComponent, ListPlantillasComponent, NewPlantillaComponent, FoldersPlantillaComponent, FileExplorerComponent,
        DetailPlantillaComponent, ListCasosComponent, NewCasoComponent, DetailCasoComponent, GestionComponent, ListPartesComponent, DetailParteComponent, NewParteComponent,
        FileUploadComponent, FileDropDirective, SafeResourceUrlPipe, GestionInstitucionComponent, GestionTribunalComponent, ListRepresentantesComponent, DetailRepresentanteComponent, NewRepresentanteComponent,
        GestionComponentFinanciero,
        RegistroPagosComponent,
        TablaFinancieraComponent,
        InfoGeneralComponent,
        CaracteristicasArbitrajeComponent,
        ComentariosInternosComponent,
        InicioComponent,
        RepresentantesComponent,
        ListLogComponent,
        LogPlataformaComponent,
        BuscadorArchivosComponent,
        HitosProcesalesComponent,
        DiasInhabilesComponent,
        CalendarioHitosComponent,
        InformesComponent],
    providers: [
        { provide: LOCALE_ID, useValue: 'es-ES' } // Configurar el locale a español
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        HttpClientModule,
        JoyrideModule.forRoot(),
        SweetAlert2Module.forRoot(),
        CoreModule,
        LayoutModule,
        AppRoutingModule,
        AdvancedTableModule,
        NgbModule,
        ReactiveFormsModule,
        FormsModule,
        Select2Module,
        BrowserAnimationsModule,
        MatSnackBarModule,
        FullCalendarModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: environment.production,
          // Register the ServiceWorker as soon as the app is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        })
    ]
})
export class AppModule { }
